// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"L_HKZHXZ","numberCell":"V3P0h5lz","yoyCell":"tGSgLL2S","yoyNeutral":"gnz0xu0N","yoyPositive":"pfzLMkTh","yoyNegative":"nLwwVhjZ"};